export const Logo = ({ dark = false, compact = false }) => {
    const height = compact ? "h-10" : "h-12 md:h-14";
    if (dark) {
        return (
            <div className="inline-flex items-center rounded-sm bg-white px-5 py-3" data-testid="brand-logo">
                <img
                    src="/assets/logo-official.webp"
                    alt="SS Engineering Works — Industrial Furnace Solutions, Since 2026"
                    className={`${height} w-auto`}
                />
            </div>
        );
    }
    return (
        <img
            src="/assets/logo-official.webp"
            alt="SS Engineering Works — Industrial Furnace Solutions, Since 2026"
            className={`${height} w-auto`}
            data-testid="brand-logo"
        />
    );
};
